module.exports = __webpack_public_path__ + "img/gera1.jpg";